import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { authGuard } from './guards/auth.guard';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';

import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { UsersComponent } from './pages/users/users.component';
import { AdminsComponent } from './pages/admins/admins.component';
import { ListingComponent } from './pages/listing/listing.';
import { CardsComponent } from './pages/cards/cards';
import { MetricsComponent } from './pages/metrics/metrics.component';
import { WishListComponent } from './pages/wishlist/wishlist';
import { CategoryComponent } from './pages/category/category';
import { EmailComponent } from './pages/email/email';
import { AgenciesComponent } from './pages/agencies/agencies';
import { CorporatesComponent } from './pages/corporates/corporates';
import { CorporateMembersComponent } from './pages/corporatemembers/corporatemembers';
import { AgencyMembersComponent } from './pages/agencymembers/agencymembers';
import { UserProfileComponent } from './components/shared/user-profile/user-profile.component';
import { EmailsComponent } from './pages/emails/emails';



export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'users', component: UsersComponent },
      { path: 'admins', component: AdminsComponent },
      { path: 'listing', component: ListingComponent },
      { path: 'metrics', component: MetricsComponent },
      { path: 'wishlist', component: WishListComponent },
      { path: 'cards', component: CardsComponent }, // placeholder
      { path: 'analytics', redirectTo: 'metrics', pathMatch: 'full' }, // redirect to metrics
        // Settings submenu routes
      { path: 'categories', component: CategoryComponent }, // placeholder
       { path: 'email', component: EmailComponent }, 
        { path: 'emails', component: EmailsComponent },
       { path: 'agencies', component: AgenciesComponent },
       { path: 'corporates', component: CorporatesComponent },
       { path: 'corporates/:id', component: CorporateMembersComponent }, 
      { path: 'agencies/:id', component: AgencyMembersComponent } ,
    { path: 'profile', component: UserProfileComponent }, ],
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '**', redirectTo: '/login' },
];